module.exports = __webpack_public_path__ + "static/media/ic_zoom_out.090610f5.svg";